module.exports = __webpack_public_path__ + "img/mild-alkaline.bb88ec5d.webp";